import { useEffect, useState } from "react";
import CalendarPopup from "./CalendarPopup";
import dayjs from "dayjs";
import { RightOutline } from "antd-mobile-icons";

const renderLabel = (value, type) => {
    return type === "multi" ? (
        <>
            Dal {dayjs(value[0]).format("DD/MM/YYYY")} al {dayjs(value[1]).format("DD/MM/YYYY")}
        </>
    ) : (
        <>{dayjs(value).format("DD/MM/YYYY")}</>
    );
};
export default function ({ minDate, value, onChange, type }) {
    const [visible, setVisible] = useState(false);
    return (
        <div
            onClick={() => setVisible(true)}
            style={{ width: "100%", cursor: "pointer", display: "flex", flexDirection: "row" }}
        >
            <span style={{ flex: 1 }}>
                {value ? renderLabel(value, type) : "Clicca per selezionare"}
            </span>
            <RightOutline />
            <CalendarPopup
                onMaskClick={() => setVisible(false)}
                value={value}
                minDate={minDate}
                type={type}
                onChange={(val) => {
                    setVisible(false);
                    onChange(val);
                }}
                visible={visible}
                onClose={() => setVisible(false)}
            />
        </div>
    );
}
